import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import { Tooltip } from '../../chassis/tooltip'
import helpHint from '../../assets/images/tooltip.svg'
import { TooltipProps } from './types'

export interface Props {
  field?: string
  fieldsBold?: boolean
  hasBottomBorder?: boolean
  noField?: boolean
  tooltip?: TooltipProps
  valuesBold?: boolean
}

export const RefiTransactionsRow: FunctionComponent<Props> = ({
  field,
  children,
  hasBottomBorder,
  valuesBold,
  fieldsBold,
  noField,
  tooltip,
}) => {
  const tooltipImg = (
    <img
      src={helpHint}
      alt=""
      className="tradein-details__listing-details--icon"
    />
  )
  return (
    <div>
      <div className="refiTransactionCard__row">
        {!noField && (
          <div
            className={`refiTransactionCard__fields ${
              fieldsBold && 'refiTransactionCard__bold'
            }`}
          >
            {field && (
              <div
                className={classnames({
                  'refiTransactionCard__fields--center': tooltip,
                })}
              >
                {field}
                {tooltip && (
                  <Tooltip
                    triggerText={tooltipImg}
                    containerClass={tooltip.toolClass}
                  >
                    <p dangerouslySetInnerHTML={{ __html: tooltip.toolText }} />
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        )}
        <div
          className={`refiTransactionCard__values ${
            valuesBold && 'refiTransactionCard__bold'
          }`}
        >
          <div>{children}</div>
        </div>
      </div>
      {hasBottomBorder && <div className="refiTransactionCard__row--hr" />}
    </div>
  )
}

RefiTransactionsRow.displayName = 'RefiTransactionsRow'
